//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import libchart from '../library/chart'
import libIKM from '../library/ikm'
import libUmum from '../library/umum'


export default {
  data() {
    return {
      alert: false,
      simpan1: false,
      model :'',
      inputSelect : [
        {id : '1', nama : 'kiken', alamat : 'beringin'},
        {id : '2',nama : 'Alung', alamat : 'Anawai'},
      ],
      date : '',

      nilaiIKM : 0,
      uraianIKM : '',
      listPendidikan : [],
      listJK : [],

      listChart : [],
      jmlResponden : '',

      dataDashboarku : {
          jml_user: 0,
          juml_kesioner: 0
      },

      tahun :'',
      semester : '',



    }
  },
  methods: {
    simulateProgress (number) {
      // we set loading state
      this[`simpan${number}`] = true
      // simulate a delay
      setTimeout(() => {
        // we're done, we reset loading state
        this[`simpan${number}`] = false
      }, 3000)
    },


    getDashboard : function(){
      fetch(this.$store.state.url.URL_masterKuesioner+'dashboard', {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {

           this.dataDashboarku = {
                jml_user: res_data.jml_user,
                juml_kesioner: res_data.juml_kesioner,
            }
      });
    },


    respondenPendidikan : function(){
      fetch(this.$store.state.url.URL_masterKuesioner+'respondenPendidikan', {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            tahun : this.tahun, 
            semester : this.semester
          })
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data)

            this.listPendidikan = res_data.pendidikan
            this.listJK = res_data.jk

            var jkk = res_data.jk

            this.chartPendidikan(jkk[0].jml, jkk[1].jml);

      });
    },

    chartPendidikan : function(laki, perempuan){
      Highcharts.chart('chartJK', {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            options3d: {
                enabled: true,
                alpha: 45,
                beta: 0
            }
        },
        title: {
            text: 'Jumlah Responden Berdasrkan Jenis Kelamin'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                depth: 35,
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.1f} %'
                },
                showInLegend: true
            }
        },
        series: [{
            type: 'pie',
            name: 'Jumlah ',
            data: [
              {
                name: 'Laki-laki',
                y: laki,
                color:'#1e88e5',
              },
              {
                name: 'Perempuan',
                y: perempuan,
                color:'#7cb342',
              },
            ]
        }]
    });
    },


    getChart : function(){
      fetch(this.$store.state.url.URL_masterKuesioner, {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            tahun : this.tahun, 
            semester : this.semester
          })
      })
          .then(res => res.json())
          .then(res_data => {

            this.listChart = res_data.data
            this.jmlResponden = res_data.jmlResponden

            console.log(res_data)


            setTimeout(() => {
              this.viewChart(this.listChart, this.jmlResponden);
              this.nilaiIKM = libIKM.ikm(this.listChart);
              this.uraianIKM = libIKM.uraian(this.listChart);
            }, 500);
      });
    },

    viewChart : function(listChart, jmlResponden){

      var idk = 'idx'+listChart[0].masterkuesioner_id
      var color = ['#1e88e5','#b3b242','#ff8a65','#c36cc6','#f95858',]

      listChart.forEach(element => {
        // console.log('idx'+element.masterkuesioner_id)
            var id = 'idx'+element.masterkuesioner_id
            var text = element.masterkuesioner_uraian


            var data = []
            
            element.opsi.forEach((element1, i) => {
              data.push({
                  name: element1.masteropsi_uraian,
                  y: element1.jml_opsi,
                  color:color[i],
              })

              
            });
          libchart.chartPie(id, text, data);
      });
 
    },





    

    async button(){
      await setTimeout(() => {
        console.log('ini query pembacaannya')
      }, 2000);
      console.log('telASO')
    },

    getAll(){

      this.getDashboard();
      this.getChart();
      this.respondenPendidikan();

    },







  },

  mounted () {

    var date = new Date();
    this.tahun = date.getUTCFullYear();
    var bulan = date.getMonth();
    this.semester = libUmum.semesterNumber(bulan+1)


    this.button();
    this.getAll();
  },
}
